import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Row } from "react-bootstrap";

import Icon from "./Icon";
import FilterSelect from "./FilterSelect";
import TableCalendarFilter from "./TableCalendarFilter";
import {
  sortItems,
  convertSortToText,
  userRoleItems,
  convertRoleToText,
  transactionTypeItems,
  convertTransactionTypeToText,
  fieldTypeItems,
  convertFieldTypeToText,
  convertProductTypeToText,
  productTypeItems,
  orderStatusItems,
  convertOrderStatusToText,
  discountCodeTypeItems,
  convertDiscountCodeTypeToText,
  convertInvoiceStatusToText,
  invoiceStatusItems,
  invoiceTypeItems,
  convertInvoiceTypeToText,
  bulkSMSTypeItems,
  convertBulkSMSTypeToText,
  convertPaymentStatusToText,
  paymentStatusItems,
  paymentGatewayItems,
  convertPaymentGatewayToText,
} from "../utils/enum";
import { addAllItemToFilters } from "../utils";

const itemsCountItems = [10, 25, 50, 75, 100, 150, 200];

const TableFilter = ({
  setStart,
  start,
  setEnd,
  end,
  setItemsCount,
  itemsCount,
  setSort,
  sort,
  setRole,
  role,
  setFieldType,
  fieldType,
  setProductType,
  productType,
  setIsActive,
  isActive,
  setIsConfirm,
  isConfirm,
  setTransactionType,
  transactionType,
  setOrderStatus,
  orderStatus,
  setInvoiceStatus,
  invoiceStatus,
  setPaymentStatus,
  paymentStatus,
  setPaymentGateway,
  paymentGateway,
  setInvoiceType,
  invoiceType,
  setDiscountCodeType,
  bulkSMSType,
  setBulkSMSType,
  discountCodeType,
}) => {
  const { pathname } = useLocation();

  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    setIsShow(false);
  }, [pathname]);

  return (
    <div className="card mb-3">
      <div className="card-body position-relative card-tools-toggle">
        <div
          className="d-flex justify-content-between align-items-center"
          type="button"
          onClick={() => setIsShow(!isShow)}
        >
          <div>جستجو پیشرفته</div>
          <Icon
            icon={`eva:arrow-ios-${isShow ? "upward" : "downward"}-fill`}
            className="text-xxl"
          />
        </div>
        {isShow && (
          <>
            <hr className="mt-3" />
            <Row className="align-items-end">
              {setItemsCount && (
                <FilterSelect
                  title="تعداد"
                  items={itemsCountItems.map((item) => ({
                    label: item,
                    value: item,
                  }))}
                  value={itemsCount}
                  onChange={setItemsCount}
                />
              )}
              {setSort && (
                <FilterSelect
                  title="چیدمان"
                  items={addAllItemToFilters(
                    sortItems.map((item) => ({
                      label: convertSortToText(item),
                      value: item,
                    })),
                    "پیشفرض"
                  )}
                  value={sort}
                  onChange={setSort}
                />
              )}
              {setIsActive && (
                <FilterSelect
                  title="وضعیت"
                  items={addAllItemToFilters([
                    {
                      label: "فعال",
                      value: "true",
                    },
                    {
                      label: "غیرفعال",
                      value: "false",
                    },
                  ])}
                  value={isActive}
                  onChange={setIsActive}
                />
              )}
              {setIsConfirm && (
                <FilterSelect
                  title="وضعیت اطلاعات"
                  items={addAllItemToFilters([
                    {
                      label: "تایید شده",
                      value: "true",
                    },
                    {
                      label: "در انتظار تایید",
                      value: "false",
                    },
                  ])}
                  value={isConfirm}
                  onChange={setIsConfirm}
                />
              )}

              {setRole && (
                <FilterSelect
                  title="نقش کاربر"
                  items={addAllItemToFilters(
                    userRoleItems.map((item) => ({
                      label: convertRoleToText(item),
                      value: item,
                    })),
                    "همه"
                  )}
                  value={role}
                  onChange={setRole}
                />
              )}

              {setFieldType && (
                <FilterSelect
                  title="نوع فیلد"
                  items={addAllItemToFilters(
                    fieldTypeItems.map((item) => ({
                      label: convertFieldTypeToText(item),
                      value: item,
                    })),
                    "همه"
                  )}
                  value={fieldType}
                  onChange={setFieldType}
                />
              )}
              {setProductType && (
                <FilterSelect
                  title="نوع محصول"
                  items={addAllItemToFilters(
                    productTypeItems.map((item) => ({
                      label: convertProductTypeToText(item),
                      value: item,
                    })),
                    "همه"
                  )}
                  value={productType}
                  onChange={setProductType}
                />
              )}
              {setTransactionType && (
                <FilterSelect
                  title="حالت تراکنش"
                  items={addAllItemToFilters(
                    transactionTypeItems?.map((item) => ({
                      label: convertTransactionTypeToText(item),
                      value: item,
                    }))
                  )}
                  value={transactionType}
                  onChange={setTransactionType}
                />
              )}
              {setOrderStatus && (
                <FilterSelect
                  title="وضعیت سفارش"
                  items={addAllItemToFilters(
                    orderStatusItems?.map((item) => ({
                      label: convertOrderStatusToText(item),
                      value: item,
                    }))
                  )}
                  value={orderStatus}
                  onChange={setOrderStatus}
                />
              )}
              {setInvoiceStatus && (
                <FilterSelect
                  title="وضعیت فاکتور"
                  items={addAllItemToFilters(
                    invoiceStatusItems?.map((item) => ({
                      label: convertInvoiceStatusToText(item),
                      value: item,
                    }))
                  )}
                  value={invoiceStatus}
                  onChange={setInvoiceStatus}
                />
              )}
              {setPaymentStatus && (
                <FilterSelect
                  title="وضعیت پرداخت"
                  items={addAllItemToFilters(
                    paymentStatusItems?.map((item) => ({
                      label: convertPaymentStatusToText(item),
                      value: item,
                    }))
                  )}
                  value={paymentStatus}
                  onChange={setPaymentStatus}
                />
              )}
              {setPaymentGateway && (
                <FilterSelect
                  title="درگاه پرداخت"
                  items={addAllItemToFilters(
                    paymentGatewayItems?.map((item) => ({
                      label: convertPaymentGatewayToText(item),
                      value: item,
                    }))
                  )}
                  value={paymentGateway}
                  onChange={setPaymentGateway}
                />
              )}
              {setInvoiceType && (
                <FilterSelect
                  title="نوع فاکتور"
                  items={addAllItemToFilters(
                    invoiceTypeItems?.map((item) => ({
                      label: convertInvoiceTypeToText(item),
                      value: item,
                    }))
                  )}
                  value={invoiceType}
                  onChange={setInvoiceType}
                />
              )}
              {setDiscountCodeType && (
                <FilterSelect
                  title="نوع کد تخفیف"
                  items={addAllItemToFilters(
                    discountCodeTypeItems?.map((item) => ({
                      label: convertDiscountCodeTypeToText(item),
                      value: item,
                    }))
                  )}
                  value={discountCodeType}
                  onChange={setDiscountCodeType}
                />
              )}
              {setBulkSMSType && (
                <FilterSelect
                  title="نوع پیامک انبوه"
                  items={addAllItemToFilters(
                    bulkSMSTypeItems.map((item) => ({
                      label: convertBulkSMSTypeToText(item),
                      value: item,
                    })),
                    "همه"
                  )}
                  value={bulkSMSType}
                  onChange={setBulkSMSType}
                />
              )}
            </Row>
            {setStart && setEnd && (
              <Row className="align-items-end">
                <TableCalendarFilter
                  setStart={setStart}
                  start={start}
                  setEnd={setEnd}
                  end={end}
                />
              </Row>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TableFilter;
